/**
 * XpBadge — badge discreta com o XP do próprio aluno (só role=player).
 *
 * Decisão v1 (CONTEXT §Pontuação): aluno vê o próprio total, não o ranking
 * da turma — evita competição direta, foca no progresso individual.
 * Animação leve ao incrementar pra dar feedback de que ganhou XP.
 *
 * Posição: top-left (top-right é do InteractionModeBadge).
 */

import { useEffect, useRef, useState } from 'react'

import { useAdapter } from '../adapter'
import { useScore } from '../hooks/useScore'
import { useSessionState } from '../hooks/useSessionState'

export function XpBadge() {
  const adapter = useAdapter()
  const { membershipId } = useSessionState()
  const { totalFor } = useScore()

  const total = totalFor(membershipId)
  const [flash, setFlash] = useState(false)
  const prevTotalRef = useRef(total)

  useEffect(() => {
    if (total !== prevTotalRef.current) {
      if (total > prevTotalRef.current) {
        setFlash(true)
        const t = setTimeout(() => setFlash(false), 800)
        prevTotalRef.current = total
        return () => clearTimeout(t)
      }
      prevTotalRef.current = total
    }
  }, [total])

  if (adapter.role !== 'player') return null
  if (!membershipId) return null

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'fixed',
        top: 12,
        left: 12,
        zIndex: 40,
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '4px 10px',
        background: flash
          ? 'color-mix(in srgb, var(--color-lab-mint, #1E9E6A) 20%, white)'
          : 'color-mix(in srgb, var(--color-lab-accent, #5B2DB8) 10%, white)',
        border: `1px solid ${flash ? 'var(--color-lab-mint, #1E9E6A)' : 'var(--color-lab-accent, #5B2DB8)'}`,
        color: 'var(--color-lab-ink, #0F1115)',
        borderRadius: 'var(--radius-lab-sm, 6px)',
        fontFamily: 'var(--font-lab-mono)',
        fontSize: 'var(--text-lab-xs, 0.75rem)',
        fontWeight: 700,
        letterSpacing: 0.3,
        transition: 'background 250ms, border-color 250ms, transform 250ms',
        transform: flash ? 'scale(1.08)' : 'scale(1)',
      }}
    >
      <span aria-hidden="true">⭐</span>
      <span>{total} XP</span>
    </div>
  )
}
